import React, { useState, useEffect } from "react";
import "../../styles/Style.css";
import axios from "axios";
import EditIcon from "../../assets/ic_edit.svg";
import { API_URL } from "../appConfig";
import { useNavigate } from "react-router-dom";
import { Puff } from "react-loader-spinner";
import Cookies from "js-cookie";
import { LoadingFailed } from "../common/LoadingError";
import { DataNotAvailable } from "../common/NoDataError";

export default function User() {
  const [data, setData] = useState([]);
  const [searchTerm, setSearchTerm] = useState("");
  const [sortedData, setSortedData] = useState([]);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState(null);
  const navigate = useNavigate();

  var header = {
    headers: {
      Authorization: Cookies.get("userToken"),
    },
  };

  useEffect(() => {
    const apiUrl = API_URL + "admin/getAllUser";
    axios
      .get(apiUrl, header)
      .then((response) => {
        setData(response.data.data);
        setLoading(false);
      })
      .catch((error) => {
        setError(error);
        setLoading(false);
      });
  }, []);
  function filterData() {
    const formattedData = data?.map((user) => {
      return {
        ...user,
      };
    });

    const filteredData = formattedData.filter((user) =>
      user.userName.toLowerCase().includes(searchTerm.toLowerCase())
    );
    setSortedData(filteredData);
  }

  useEffect(() => {
    filterData();
  }, [searchTerm, data]);
  return (
    <div className="records table-responsive">
      <div className="record-header">
        <div className="title">
          <span className="text-xl font-semibold">USER DETAILS</span>
        </div>
        <div className="flex gap-4 py-2">
          <input
            type="search"
            placeholder="Search User"
            className="border-2 border-gray-200 focus:outline-none rounded-lg px-4 w-[150px] sm:w-auto"
            value={searchTerm}
            onChange={(e) => setSearchTerm(e.target.value)}
          />
          <button
            className="w-[40px] h-[40px] bg-black hover:bg-gray-600 rounded-full text-white"
            onClick={() => navigate("/user/create")}
          >
            +
          </button>
        </div>
      </div>

      {loading ? (
        <div className="loader-container">
          <div className="loader">
            <Puff
              height="80"
              width="80"
              radius={1}
              color="#747474"
              ariaLabel="puff-loading"
              wrapperStyle={{}}
              wrapperClass=""
              visible={true}
            />
          </div>
        </div>
      ) : null}

      {error ? <LoadingFailed /> : null}

      {!loading && !error && (
        <div className="rounded-md overflow-x-auto">
          {sortedData ? (
            <table className="table-container">
              <thead>
                <tr>
                  <th className="text-center px-2">#</th>
                  <th className="text-center px-2">USER ID</th>
                  <th className="text-center px-2">USER NAME</th>
                  <th className="text-center px-2">PASSWORD</th>
                  <th className="text-center px-2">STATUS</th>
                  <th className="text-center px-2">ACTIONS</th>
                </tr>
              </thead>
              <tbody>
                {sortedData?.map((user, index) => (
                  <tr key={index}>
                    <td className="text-center px-2">{index + 1}</td>
                    <td className="text-center px-2">{user.userId}</td>
                    <td className="text-center px-2">{user.userName}</td>
                    <td className="text-center px-2">{user.password}</td>
                    <td className="text-center px-2">
                      <span
                        className={`paid ${
                          user.status === true ? "completed" : "pending"
                        }`}
                      >
                        {user.status === true ? "Active" : "Expired"}
                      </span>
                    </td>
                    <td className="text-center px-2">
                      <div
                        className="actions"
                        onClick={() =>
                          navigate("/user/create", {
                            state: { userData: user },
                          })
                        }
                      >
                        <span>
                          <img src={EditIcon} alt="edit_icon" />
                        </span>
                      </div>
                    </td>
                  </tr>
                ))}
              </tbody>
            </table>
          ) : (
            <DataNotAvailable />
          )}
        </div>
      )}
    </div>
  );
}
